import { useState } from "react";
import HandleRenderDiv from "./HandleRenderDiv";
import { useSelector } from "react-redux";

const FindAJob = ({ stepBack, backToLogin, onClose }) => {
  const { registerStep } = useSelector(
    (state) => state.freelancer.auth
  );
  const [isSubscription, setIsSubscription] = useState(true);

  return (
    <>
      <div
        className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
          <div class="modal-content">
            <div class="modal-header border-0 p-0 pb-2">
              <button
                type="button"
                class="btn-close ct_close_position_right12"
                onClick={onClose}
              ></button>
            </div>
            <HandleRenderDiv
              registerStep={registerStep}
              stepBack={stepBack}
              backToLogin={backToLogin}
              onClose={onClose}
              setIsSubscription={() => setIsSubscription(false)}
              isSubscription={isSubscription}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FindAJob;
